import {
  GetSegmentChangeHistoryRequestPayload,
  GetSegmentChangeHistoryResponse,
} from 'types/segments/segments.types';
import {
  CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS,
  ClearSegmentChangeHistorySuccessAction,
  GET_SEGMENT_CHANGE_HISTORY_FAILURE,
  GET_SEGMENT_CHANGE_HISTORY_REQUEST,
  GET_SEGMENT_CHANGE_HISTORY_SUCCESS,
  GetSegmentChangeHistoryFailureAction,
  GetSegmentChangeHistoryRequestAction,
  GetSegmentChangeHistorySuccessAction,
} from './segmentChangeHistory.types';

export const getSegmentChangeHistoryRequest = (
  payload: GetSegmentChangeHistoryRequestPayload
): GetSegmentChangeHistoryRequestAction => ({
  type: GET_SEGMENT_CHANGE_HISTORY_REQUEST,
  payload,
});

export const getSegmentChangeHistorySuccess = (
  response: GetSegmentChangeHistoryResponse
): GetSegmentChangeHistorySuccessAction => ({
  type: GET_SEGMENT_CHANGE_HISTORY_SUCCESS,
  payload: response,
});

export const getSegmentChangeHistoryFailure = (
  error: string
): GetSegmentChangeHistoryFailureAction => ({
  type: GET_SEGMENT_CHANGE_HISTORY_FAILURE,
  payload: error,
});

export const clearSegmentChangeHistorySuccess =
  (): ClearSegmentChangeHistorySuccessAction => ({
    type: CLEAR_SEGMENT_CHANGE_HISTORY_SUCCESS,
  });
